import { Button } from "@gds-react/core";
import { Description, Inner, Title, Screen, ImageWrapper } from "./404.styles";
import { useNavigate } from "react-router";
import { routes } from "../../utils/routeHelper";
import { useTranslation } from "react-i18next";
import Lottie from "react-lottie";
import pageNotFoundnimation from "./animation";
import { useStore } from "../../store/store";
import { useEffect } from "react";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const setActiveMenuId = useStore.useSetActiveMenuId();

  useEffect(() => {
    setActiveMenuId(undefined);
  }, []);

  return (
    <Screen>
      <Inner>
        <ImageWrapper>
          <Title>{t("404Page.title")}</Title>

          <Lottie
            speed={0.4}
            width={200}
            height={200}
            options={{
              loop: true,
              animationData: pageNotFoundnimation,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
                clearCanvas: true,
              },
            }}
          />
        </ImageWrapper>
        <Description>{t("404Page.description")}</Description>
        <Button size="large" onClick={() => navigate(routes.dashboard.get())}>
          {t("404Page.buttonText")}
        </Button>
      </Inner>
    </Screen>
  );
}
